import { ComponentPropsWithRef, FC } from 'react';
import { PlcFlatRectLoader } from '@components/Loaders/PlcFlatRectLoader.component';
import classnames from 'classnames';

const PlcRow: FC<ComponentPropsWithRef<'tr'> & { header?: boolean; isLoading?: boolean }> = ({
  className,
  header,
  isLoading,
  ...rest
}) => {
  const rootClass = classnames('plc-table-row', header ? 'plc-table-row-header' : '', className);
  return isLoading ? (
    <tr className={rootClass}>
      <td>
        <PlcFlatRectLoader className={rootClass} uniqueKey="plc-row" width={100} />
      </td>
    </tr>
  ) : (
    <tr className={rootClass} {...rest} />
  );
};

export { PlcRow };
